class GiftBag extends HTMLElement {
  constructor() {
    super();

    this.giftBagId = this.dataset.giftBagId; // ID do produto
    this.miniCart = document.querySelector('mini-cart'); // Referência ao carrinho lateral
    this.checkbox = this.querySelector('[name="attributes[gift-bag]"]');
    this.loadingOverlay = this.querySelector('.loading-overlay');

    this.checkbox.addEventListener('change', (event) => {
      if (event.target.checked) {
        this.addGiftBag();
      } else {
        this.removeGiftBag();
      }
    });
  }

  // Adiciona o produto do gift-bag e atualiza o carrinho lateral
  addGiftBag() {
    this.toggleLoading(true);

    const body = JSON.stringify({
      updates: { [this.giftBagId]: 1 }, // Adiciona 1 unidade
      attributes: { 'gift-bag': 'yes' },
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body
    })
      .then((response) => {
        if (!response.ok) throw new Error('Erro ao adicionar o gift-bag.');
        return response.json();
      })
      .then((response) => {
        this.toggleLoading(false);
        this.updateMiniCart(response); // Atualiza o carrinho lateral
        this.updateCheckboxState(true);
      })
      .catch((error) => {
        console.error(error);
        this.toggleLoading(false);
        this.updateCheckboxState(false);
      });
  }

  // Remove o produto do gift-bag e atualiza o carrinho lateral
  removeGiftBag() {
    this.toggleLoading(true);

    const body = JSON.stringify({
      updates: { [this.giftBagId]: 0 }, // Remove o produto
      attributes: { 'gift-bag': '' },
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body
    })
      .then((response) => {
        if (!response.ok) throw new Error('Erro ao remover o gift-bag.');
        return response.json();
      })
      .then((response) => {
        this.toggleLoading(false);
        this.updateMiniCart(response); // Atualiza o carrinho lateral
        this.updateCheckboxState(false);
      })
      .catch((error) => {
        console.error(error);
        this.toggleLoading(false);
        this.updateCheckboxState(true);
      });
  }

  // Atualiza o carrinho lateral
  updateMiniCart(response) {
    if (this.miniCart) {
      this.miniCart.renderContents(response);
    }
  }

  // Atualiza o estado visual do checkbox
  updateCheckboxState(isChecked) {
    this.checkbox.checked = isChecked;
  }

  // Alterna o estado de carregamento
  toggleLoading(isLoading) {
    if (isLoading) {
      this.loadingOverlay.classList.remove('hidden');
    } else {
      this.loadingOverlay.classList.add('hidden');
    }
  }

  // Define as seções a serem renderizadas no carrinho
  getSectionsToRender() {
    return [
      { id: 'mini-cart', section: 'mini-cart', selector: '.shopify-section' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
    ];
  }
}

customElements.define('gift-bag', GiftBag);
